import { Show } from 'bz-core-controls';
import Report from 'bz-core-controls/controls/general/report';
import LoadingSlider from 'bz-core-controls/controls/layout/loading-slider';
import { computed } from 'mobx';
import { inject, observer, Provider } from 'mobx-react';
import React from 'react';
import HeaderControl from './controls/header-control';
import ViewStore from './stores/view-store';

import './style.css';
import { Accordion, Divider, View } from '@zinc/ui';
import Actions from './controls/header-control/controls/actions';
import Title from './controls/header-control/controls/title';
import Badge from './controls/header-control/controls/title/controls/badge';

@inject('clinicalStore')
@observer
class CaseReport extends React.Component {
  vm: ViewStore;

  static defaultProps = {
    viewable: false,
    onEdit: () => {}
  };

  constructor(props) {
    super(props);
    let { store, clinicalStore } = props;
    this.vm = new ViewStore(store, clinicalStore.prontoStore);
    this.vm.open = !!props.viewable;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.viewable) this.vm.open = true;
  }

  render() {
    if (!this.show) {
      return null;
    }

    const { vm, className } = this;
    const { navKey, onEdit } = this.props;
    const { open, toggleOpen } = this.vm;

    return (
      <Provider vm={vm}>
        <View
          backgroundColor="page"
          borderRadius="medium"
          shadow="raised"
          paddingEnd={4}
          attributes={{ id: navKey }}
          className="clinical-page-newux"
        >
          <Accordion active={open} onToggle={toggleOpen}>
            <Accordion.Trigger>
              <View direction="row" padding={2} gap={2} justify="space-between" align="center">
                <Title />
                <View direction="row" gap={2} align="center">
                  <Badge />
                  <Actions onEdit={onEdit} />
                </View>
              </View>
            </Accordion.Trigger>
            <Accordion.Content>
              <LoadingSlider loading={vm.loading}>
                <Divider />
                <View padding={4} gap={2}>
                  {open && <ReportWrapper />}
                </View>
              </LoadingSlider>
            </Accordion.Content>
          </Accordion>
        </View>
      </Provider>
    );
  }

  @computed
  get show() {
    let { referralStore } = this.props.clinicalStore.caseStore;

    const canReportToPronto = !!referralStore && referralStore.referral.canReport;
    return !!canReportToPronto;
  }

  @computed
  get open() {
    let { navKey, clinicalStore } = this.props;
    let { status } = clinicalStore.prontoStore;
    let { open, report, loading } = this.vm;
    if (!!loading || status !== 'fullfilled' || !report || report.status === 3) return false;
    return open || clinicalStore.activePageKeys.indexOf(navKey) > -1;
  }

  @computed
  get className() {
    let css = ['clinical-page', 'pronto-report'];
    css.push(this.open ? 'open' : '');
    return css.join(' ');
  }
}

@inject('vm')
@observer
class ErrorMessage extends React.Component {
  render() {
    if (!this.show) return null;

    let { message } = this.props.vm.report;

    return <div className="error-message">{message}</div>;
  }

  @computed
  get show() {
    let { message } = this.props.vm.report;
    return !!message && !!message.trim();
  }
}

@inject('vm')
@observer
class ReportWrapper extends React.Component {
  render() {
    return !!this.exists ? <Report store={this.props.vm.report.draft} /> : null;
  }

  @computed
  get exists() {
    return !!this.props.vm.report;
  }
}

export default CaseReport;
